import React from "react";

import DOMPurify from "dompurify";
import { useAppLoadingContext } from "../../Context/AppLoadingContext";
import { AppLoadingContextTypes } from "../../Context/ContextTypes/AppLoadingContextTypes";
import { Box, Grid, Link, Typography } from "@mui/material";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";

type BankToolPropTypes = {
  carouselId: string;
  headertext: string;
  linkText: string;
  linkUrl: string;
  linkAriaLabel: string;
  toolItems: Array<{
    itemText: string;
    itemUrl: string;
    itemAriaLabel: string;
  }>;
  isInEditor: boolean;
  cqPath: string;
  cqType: string;
};

export default function BankToolsReact(props: BankToolPropTypes) {
  console.log(props);
  // translation
  const { translationsData } = useAppLoadingContext() as AppLoadingContextTypes;
  const DomPurify = (tag: string) => {
    return DOMPurify.sanitize(translationsData[tag]);
  };

  const translatedData = {
    // title and button
    headerText: DomPurify(props.headertext),
    linkText: DomPurify(props.linkText),
    linkUrl: DomPurify(props.linkUrl),
    linkAriaLabel: DomPurify(props.linkAriaLabel),
  };

  return (
    <Box
      component="section"
      id="bankToolSection"
      className="content-section"
      sx={{
        backgroundColor: "rgba(18, 18, 18)",
      }}
    >
      <Grid container xs={12} sm={12} md={12} lg={12} >
        <Box component="div" className="trianleBgBorder" sx={{height:{xs:'16px',lg:"32px"}}} />
      </Grid>
      <Grid container display="flex" flexDirection="column" alignItems="center">
        <Typography
          variant="h2"
          color="#fff !important"
          textAlign={{ xs: "center", sm: "center", md: "center", lg: "left" }}
          sx={{
            padding: { xs: "5% 2%", sm: "5% 18%", md: "5% 18%", lg: "5% 0% 2% 0%" },
            fontSize: { xs: "36px", sm: "36px", lg: "36px" },
            lineHeight: "normal !important",
          }}
        >
          {translatedData.headerText}
        </Typography>

        <Grid
          container
          xs={12}
          sm={6}
          md={6}
          lg={12}
          justifyContent="center"
          gap={{ sm: 0, lg: 2 }}
          sx={{ padding: "0px 10px" }}
        >
          {props?.toolItems?.map((item) => (
            <Grid item xs={12} lg={3.3} margin="10px 0px">
              <Link
                variant="body1"
                className="boxLinks"
                href={DomPurify(item.itemUrl)}
                aria-label={DomPurify(item.itemAriaLabel)}
                target="_self"
                color="#fff"
                sx={{
                  height: "100%",
                  fontWeight: "700",
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  textDecoration: "none",
                  fontSize: "16px",
                  backgroundColor: "rgba(38, 38, 38)",
                  borderRadius: "3px",
                  border: "2px solid white",
                  textAlign: "center",
                  padding: "10px",
                  "&:hover": {
                    textDecoration: "underline",
                  },
                  "&:focus": {
                    textDecoration: "underline",
                  },
                }}
              >
                {DomPurify(item.itemText)}
              </Link>
            </Grid>
          ))}
        </Grid>

        <Typography
          variant="body1"
          component={Link}
          display="flex"
          alignItems="center"
          textAlign={{ xs: "center", sm: "center", md: "center", lg: "left" }}
          sx={{
            display: "flex",
            justifyContent: { xs: "center", sm: "center", md: "center", lg: "left" },
            padding: { xs: "0px 10px 0px 10px", sm: "0px", md: "0px", lg: "30px 0px" },
            textDecoration: "underline white !important",
            fontSize: "18px",
            margin: { xs: "30px 0px", sm: "30px 0px", md: "30px 0px", lg: "0px" },
          }}
        >
          <Link
            href={translatedData.linkUrl}
            aria-label={translatedData.linkAriaLabel}
            color="#fff"
            target="_self"
            sx={{
              textDecoration: "underline white !important",
            }}
          >
            {translatedData.linkText}
          </Link>
          <KeyboardArrowRight
            aria-hidden={true}
            sx={{ height: "1.2rem", width: "1.2rem", color: "white" }}
          />
        </Typography>
      </Grid>
      <Grid container xs={12} sm={12} md={12} lg={12} paddingTop="20px">
        <Box component="div" className="trianleBgBorder" sx={{height:{xs:'16px',lg:"32px"}}} />







      </Grid>
    </Box>
  );
}
